import Analytics from "analytics";
import segmentPlugin from '@analytics/segment';

import config from "config";

export default Analytics({
    app: 'speedweaver-web-editor',
    plugins: [
        segmentPlugin({
            writeKey: config.segmentKey
        })
    ]
});